//import { FakeApiManager as ApiManager } from "./FakeApiManager.js";
import { ApiManager } from "./ApiManager.js";

export default ApiManager;